import { render, staticRenderFns } from "./aliPay.vue?vue&type=template&id=e60e827e&scoped=true"
import script from "./aliPay.vue?vue&type=script&lang=js"
export * from "./aliPay.vue?vue&type=script&lang=js"
import style0 from "./aliPay.vue?vue&type=style&index=0&id=e60e827e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60e827e",
  null
  
)

export default component.exports